import { Col, Container, Row } from "react-bootstrap";
import { BackLink, CTA, Description, Image, Title } from "@/ui";
import clsx from "classnames";
import classes from "./styles.module.scss";
import ArrowLeft from "@/assets/ArrowLeft.svg";


export const HeaderSideImage = ({
  className,
  containerClassName,
  img,
  showBackLink,
  back,
  title,
  description,
  showCta,
  cta,
  bgColor,
  textColor,
}) => {
  return (
    <div className={clsx(className, classes.header, `bg-${bgColor}`, `text-${textColor}`)}>
      <Container fluid className={containerClassName}>
        <Row>
          <Col xs={12} md={6} className={clsx(classes.header__content, "px-0 px-md-5")}>
            {showBackLink && (
              <a className={clsx(classes.back, "mb-3")} href={back.href}>
                <ArrowLeft />
                {back.placeholder}
              </a>
            )}
            <Title className="mb-0" title={title} tag="h1" />
            <div className="me-4">
              <Description className="mt-4" description={description} />
              {showCta && <CTA className="mt-4" label={cta.label} href={cta.href} variant={cta.variant} />}
            </div>
          </Col>
          <Col xs={12} md={6} className="px-0">
            <img src={img?.url} alt={img?.alt}/>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeaderSideImage;
